import * as THREE from 'three';
import Pistol from '../weapons/Pistol.js';

export class ProjectileManager {
    constructor(scene) {
        this.scene = scene;
        this.projectiles = [];
        this.speed = 30; // Increased speed for better visibility
        this.hitboxSize = new THREE.Vector3(1, 1, 1);

        // Reusable geometries and materials
        this.projectileGeometry = new THREE.SphereGeometry(0.05, 8, 8); // Smaller sphere
        this.projectileMaterial = new THREE.MeshBasicMaterial({ color: 0xffffff }); // White projectile
        
        console.log("ProjectileManager initialized");
    }

    createProjectile(origin, direction, owner) {
        if (!origin || !direction) {
            console.error("Invalid parameters for createProjectile:", { origin, direction });
            return null;
        }
        
        try {
            // Create projectile mesh
            const projectile = new THREE.Mesh(
                new THREE.SphereGeometry(0.05, 8, 8),
                new THREE.MeshBasicMaterial({ color: 0xffffff })
            );

            // Set initial position and velocity
            projectile.position.copy(origin);
            projectile.velocity = direction.normalize().multiplyScalar(this.speed);
            projectile.damage = owner?.damage || 25;
            projectile.owner = owner;
            projectile.destroyed = false;
            projectile.createdAt = performance.now();

            // Add to scene and tracking
            this.scene.add(projectile);
            this.projectiles.push(projectile);
            
            // Add a point light to make projectile more visible
            const light = new THREE.PointLight(0xffff00, 1, 3);
            projectile.add(light);
            
            console.log(`Projectile created at ${origin.x.toFixed(2)}, ${origin.y.toFixed(2)}, ${origin.z.toFixed(2)} with direction ${direction.x.toFixed(2)}, ${direction.y.toFixed(2)}, ${direction.z.toFixed(2)}`);
            return projectile;
        } catch (error) {
            console.error("Error creating projectile:", error);
            return null;
        }
    }

    updateProjectiles() {
        const deltaTime = 1 / 60; // Assume 60FPS or use actual delta time
        const now = performance.now();
        
        for (let i = this.projectiles.length - 1; i >= 0; i--) {
            const projectile = this.projectiles[i];
            
            if (projectile.destroyed) continue;
            
            // Update position based on velocity and delta time
            projectile.position.add(projectile.velocity.clone().multiplyScalar(deltaTime));
            
            // Periodically log projectile position for debugging
            if (now % 500 < 20) {
                console.log(`Projectile at: ${projectile.position.x.toFixed(2)}, ${projectile.position.y.toFixed(2)}, ${projectile.position.z.toFixed(2)}`);
            }
                
            try {
                // Check collisions with terrain
                const terrainHeight = window.chunkManager?.getHeightAt(
                    projectile.position.x,
                    projectile.position.z
                );

                // Check collisions with zombies
                const hitZombie = window.zombieManager?.checkProjectileCollision(projectile);
                
                if (terrainHeight !== undefined && projectile.position.y <= terrainHeight) {
                    console.log("Projectile hit terrain");
                    this.destroyProjectile(projectile, i);
                } else if (hitZombie) {
                    console.log(`Projectile hit zombie for ${projectile.damage} damage`);
                    window.zombieManager.damageZombie(hitZombie, projectile.damage, projectile.owner);
                    this.destroyProjectile(projectile, i);
                } else if (now - projectile.createdAt > 5000) { // 5 second lifetime
                    console.log("Projectile lifetime expired");
                    this.destroyProjectile(projectile, i);
                }
            } catch (error) {
                console.error("Error in projectile collision check:", error);
                this.destroyProjectile(projectile, i);
            }
        }
    }

    destroyProjectile(projectile, index) {
        this.scene.remove(projectile);
        this.projectiles.splice(index, 1);
    }

    update(deltaTime) {
        for (let i = this.projectiles.length - 1; i >= 0; i--) {
            const projectile = this.projectiles[i];
            projectile.position.add(projectile.velocity.clone().multiplyScalar(deltaTime));
            console.log(`Projectile updated: ${projectile.position.x.toFixed(2)}, ${projectile.position.y.toFixed(2)}, ${projectile.position.z.toFixed(2)}`);

            if (window.zombieManager?.checkProjectileCollision(projectile)) {
                console.log("Projectile hit a zombie!");
                this.scene.remove(projectile);
                this.projectiles.splice(i, 1);
            } else if (projectile.position.distanceTo(new THREE.Vector3(0, 0, 0)) > 200) {
                console.log("Projectile exceeded max range");
                this.scene.remove(projectile);
                this.projectiles.splice(i, 1);
            }
        }
    }
}
